// @flow
import Tabs from './Tabs';

export * from './TabItem';

export default Tabs;
